import { createPublicClient, http } from 'viem';
import { publicActionsL1, publicActionsL2 } from 'viem/op-stack';
import { getTokenNetwork } from '../utils/TokenNetwork';
import { activeChain } from '../utils/CheckNetwork';

export const publicClientL2 = createPublicClient({
  chain: activeChain,
  transport: http(),
}).extend(publicActionsL2());

export const publicClientL1 = createPublicClient({
  chain: getTokenNetwork(),
  transport: http("https://rpc.ankr.com/eth"),
}).extend(publicActionsL1());
